<template>
	<ol>
		<li :class="{'message': 1, 'active': page === 'TheFormMessage'}"><a href="">Message</a></li>
		<li :class="{'gift': 1, 'active': page === 'TheFormGift'}"><a href="">Select a Gift</a></li>
		<li :class="{'confirmation': 1, 'active': page === 'TheFormPayment'}"><a href="">Confirmation</a></li>
	</ol>
</template>

<script>
export default {
	props: ['page'],
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';

	ol { position: relative; z-index: 9; display: flex; list-style: none; margin: 0; padding: 0; counter-reset: section;
		li { padding: 1rem 0; background-color: @blue; text-align: center; border-right: 2px dotted white;
			&.message { width: 30%; }
			&.gift { width: 35%; }
			&.confirmation { width: 35%; }
			&.active { position: relative; background-color: @green;
				&:after { display: block; content: ""; .bottom-left(-8px, 50%); margin-left: -9px;; .triangle-b(18px, 8px, @green); }
			}
			&:before { counter-increment: section; content: counter(section); display: inline-block; padding: 9px; .bold(); line-height: 0.6; color: white; border: 2px solid white; border-radius: 50%; }
			a { display: block; margin-top: 0.5rem; .bold(); color: white; text-decoration: none; }
			&.active, &:last-of-type { border-right: none; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormNavigation.vue